import { ScreenId } from "@/js/value-objects/screen-id";
export class LalertNotificationScreenMode {
  // 新規作成
  static CREATE = "lalert-notification-create";
  // 編集
  static EDIT = "lalert-notification-edit";
  // 参照
  static VIEW = "lalert-notification-view";
  // コピーして編集
  static DUPLICATE = "lalert-notification-duplicate";

  /**
   * コンストラクタ
   * @param {*} value Routerのname属性
   */
  constructor(value) {
    this.value = value;
  }
  /**
   * インスタンス生成
   * @param {*} value Routerのname属性
   * @returns LalertNotificationScreenModeインスタンス
   */
  static factory(value) {
    return new LalertNotificationScreenMode(value);
  }
  /**
   * モード判定（新規作成）
   * @returns true：「新規作成」モード、false：「新規作成」モード以外
   */
  isCreate() {
    return this.value === LalertNotificationScreenMode.CREATE;
  }
  /**
   * モード判定（編集）
   * @returns true：「編集」モード、false：「編集」モード以外
   */
  isEdit() {
    return this.value === LalertNotificationScreenMode.EDIT;
  }
  /**
   * モード判定（参照）
   * @returns true：「参照」モード、false：「参照」モード以外
   */
  isView() {
    return this.value === LalertNotificationScreenMode.VIEW;
  }
  /**
   * モード判定（コピーして編集）
   * @returns true：「コピーして編集」モード、false：「コピーして編集」モード以外
   */
  isDuplicate() {
    return this.value === LalertNotificationScreenMode.DUPLICATE;
  }
  /**
   * 画面ID取得
   * @returns 画面ID
   */
  getScreenId() {
    let screenId = "";
    switch (this.value) {
      case LalertNotificationScreenMode.CREATE:
        // 新規登録
        screenId = ScreenId.SF2103;
        break;
      case LalertNotificationScreenMode.EDIT:
        // 編集
        screenId = ScreenId.SF2103;
        break;
      case LalertNotificationScreenMode.VIEW:
        // 参照
        screenId = ScreenId.SF2102;
        break;
      case LalertNotificationScreenMode.DUPLICATE:
        // コピーして編集
        screenId = ScreenId.SF2103;
        break;
      default:
        break;
    }
    return screenId;
  }
}
